export default __webpack_public_path__ + "static/media/school-2051712_1920.c0e0cd3e.jpg";